import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
// Redux
import { useSelector } from "react-redux";
// Constants
import { pathHomePage, roleAccess, userRoles } from "./constants";

const ValidateSession = () => {
  const [redirectTo, setRedirectTo] = useState("");
  const isLoggedIn = useSelector(({ user }) => user.isLoggedIn);
  const userRole = useSelector(({ user }) => user.userRole);

  useEffect(() => {
    if (!isLoggedIn) {
      return setRedirectTo(`${pathHomePage}/`);
    }
    // Los distribuidores solo ven su vista: cualquier otra los devuelve a ella.
    if (userRole === userRoles.DISTRIBUTOR) {
      setRedirectTo(`${pathHomePage}${roleAccess[userRoles.DISTRIBUTOR].landingPage}`);
    }
  }, [isLoggedIn, userRole]);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }
};

export default ValidateSession;
